import { useState, FormEvent } from 'react';
import '../styles/login.css';
import '../styles/forgotPassword.css';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase';
import { Page, f7 } from 'framework7-react';
import logo from '@assets/icon.png';

function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const isFormValid = email.trim() !== '' && /.+@.+\..+/.test(email);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await sendPasswordResetEmail(auth, email);
      f7.dialog.alert('Password reset email sent');
      setEmail('');
    } catch {
      f7.dialog.alert('Error sending password reset email');
    } finally {
      setIsLoading(false);
    }
  };

  const goBack = () => {
    f7.views.main.router.back();
  };

  return (
    <Page name="forgot-password" className="auth-page">
      <div className="login-wrapper">
        <img src={logo} alt="Logo" className="login-logo" />
        <div className="login-title">Forgot password?</div>
        <div className="login-subtitle">
          No worries, we'll send you instructions to reset.
        </div>
        <form className="login-form" onSubmit={handleSubmit}>
          <label htmlFor="reset-email">Confirm email address</label>
          <input
            id="reset-email"
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button
            type="submit"
            className="login-btn"
            disabled={!isFormValid || isLoading}
          >
            {isLoading ? 'Sending...' : 'Reset password'}
          </button>
        </form>
        <div className="go-back-container">
          <button type="button" className="go-back-btn" onClick={goBack}>
            <i className="icon icon-back go-back-icon" />
            Go back
          </button>
        </div>
      </div>
    </Page>
  );
}

export default ForgotPasswordPage;
